function fadeOut(element) {
    var opacity = 1;
    var timer = setInterval(function () {
        if (opacity <= 0.1){
            clearInterval(timer);
            element.style.display = 'none';
        }
        element.style.opacity = opacity;
        element.style.filter = 'alpha(opacity=' + opacity * 100 + ")";
        opacity -= opacity * 0.1;
    }, 10);
}

function fadeIn(element) {
    var opacity = 0.2;
    element.style.display = 'block';
    
    var timer = setInterval(function () {
        if (opacity >= 1){
            clearInterval(timer);
        }
        element.style.opacity = opacity;
        element.style.filter = 'alpha(opacity=' + opacity * 100 + ")";
        opacity += opacity * 0.1;
    }, 10);
}

window.addEventListener("load", function () {
    //message
    var messageEl = document.getElementById("message");
    var messageTimeout = null;    
    messageEl.addEventListener("click", function() {
        fadeOut(this);
        window.clearTimeout(messageTimeout);
    });

    //product add buttons
    var buttons = document.querySelectorAll(".add-to-cart button");

    for (var i = 0; i < buttons.length; i++) {
        buttons[i].addEventListener("click", function (e) {
            e.preventDefault();
            var variant = e.currentTarget.parentElement.parentElement.querySelector(".variants select.product option:checked").value;
            var grind = e.currentTarget.parentElement.parentElement.querySelector(".variants select.grind option:checked").value;
            var qty = e.currentTarget.parentElement.parentElement.querySelector("input[name='quantity']");
            var quantity = qty && qty.value !== "" ? qty.value : 1

            document.querySelector("#AddToCartForm input#id").value = variant;
            document.querySelector("#AddToCartForm input.grind").value = grind;
            document.querySelector("#AddToCartForm input.grind").value = quantity;

            var cartCounters = document.querySelectorAll("a.cart-btn aside");
            for(var i = 0; i < cartCounters.length; i++){
                var newCount = parseInt(cartCounters[i].innerText.trim()) + parseInt(quantity);
                cartCounters[i].innerText = newCount;
            }

            var request = new XMLHttpRequest();
            request.open("POST", "/cart/add.js", true);
            request.setRequestHeader("Content-Type", "application/json");
            request.onreadystatechange = function () {
              if (request.readyState != 4 || request.status != 200) 
              {
                return;
              }

              var response = JSON.parse(request.responseText);
              document.querySelector("#message label").innerHTML = "added <strong>"+ response.items[0].title +"</strong> to your cart";
              fadeIn(messageEl);

              window.clearTimeout(messageTimeout);

              messageTimeout = setTimeout(function() {
                fadeOut(messageEl);
                document.querySelector("#message label").innerHTML = "";
              }, 8 * 1000);
            };

            request.send(JSON.stringify({ items: [{ 'quantity': quantity, 'id': variant, 'properties': { 'grind': grind }}] }));
            qty.value = 1;
        });
    }
});